<div class="dialog">
  <div class="dialog-background" (click)="onCancel()"></div>
  <div class="dialog-content">
    <div class="content">
      <h2>{{ 'account.reminder.IBAN.dialog.title' | translate }}</h2>
      <p [innerHtml]="'account.reminder.IBAN.dialog.p1' | translate"></p>
      <form [formGroup]="reminderForm" (ngSubmit)="onSubmit()">
        <app-ui-datetime-reminder [currentLang]="currentLang" formControlName="dateTime"></app-ui-datetime-reminder>
        <div class="dialog-buttons">
          <button type="button" class="ui-button secondary" (click)="onCancel()">
            <span>{{ 'account.reminder.IBAN.dialog.CTA.cancel' | translate }}</span>
          </button>
          <button type="submit" class="ui-button" [class.loading]="loading">
            <span class="icon-i-windmill"></span>
            <span>{{ 'account.reminder.IBAN.dialog.CTA.set' | translate }}</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
